export default function codeunitLength(source) {
    return (source && source.length) || 0;
}
//# sourceMappingURL=codeunitLength.js.map